import { Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Compiler } from '@angular/core';
import { TokenResponseModel } from '../_models';
import { Helpers } from '../../helpers';
import { TokenRequestModel } from '../_models/Request/TokenRequestModel';
import { ApplicationResponseModel } from '@global-models/Response/ApplicationResponseModel';
import { MenuResponseModel } from '@global-models/Response/MenuResponseModel';
import { DashboardItemResponseModel } from '@global-models/Response/DashboardItemResponseModel';
import { UserResponseModel } from '../_models/Response/UserResponseModel';
import { ApiSendService } from '@global-services/ApiSend.service';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { GetReCaptchaRequestModel } from '../_models/Request/GetReCaptchaRequestModel';
import { GetReCaptchaResponseModel } from '../_models/Response/GetReCaptchaResponseModel';
import { AppHelper } from '@shared-helpers/app-helper';
import { ParameterService } from '../../vbt-ticari/common/_services/Parameter.service';


@Injectable()
export class AuthenticationService {
  public results: Array<ApplicationResponseModel>;
  public menuresults: Array<MenuResponseModel>;

  constructor(private _apiservice: ApiSendService,
    private _router: Router,
    private _parameterService: ParameterService,
    private _runtime: Compiler) {

  }

  public async changeFirm(email: string, firmId: number = 0) {
    const tokenmodel = new TokenRequestModel();
    tokenmodel.Email = email;
    tokenmodel.FirmId = firmId;

    await this.clearCache();
    return await this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/Account/ChangeFirm', tokenmodel)
      .then(async responsetoken => {
        const tokenresponsemodel = (responsetoken || new TokenResponseModel()) as TokenResponseModel;
        if (tokenresponsemodel.Token != null && tokenresponsemodel.Token != undefined) {

          tokenmodel.Password = '';
          localStorage.setItem('DashboardToken', JSON.stringify(tokenresponsemodel));
          localStorage.setItem('DashboardPass', JSON.stringify(tokenmodel));

          return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetAuthorizedUserInfo')
            .then(async result => {
              const userresponsemodel = (result || new UserResponseModel()) as UserResponseModel;

              if (tokenresponsemodel) {
                if (tokenresponsemodel.Token !== undefined) {
                  if (tokenmodel.FirmId > 0) {
                    userresponsemodel.FirmId = tokenmodel.FirmId;
                  }
                  localStorage.setItem('DashboardUser', JSON.stringify(userresponsemodel));

                  return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice,
                    '/api/Dashboard/GetDashboardItems?UserId=' + userresponsemodel.Id)
                    .then(async response => {
                      const dashboardItems = (response || new DashboardItemResponseModel()) as DashboardItemResponseModel;

                      if (dashboardItems.Applications.length > 0) {
                        localStorage.setItem('DashboardItems', JSON.stringify(dashboardItems));
                        this.results = dashboardItems.Applications;
                        // tslint:disable-next-line:max-line-length
                        const applicationmenustatus = await this.getApplicationMenus()
                        await this.GetParameters();

                        if (applicationmenustatus !== true) {
                          Helpers.setLoading(true);
                          // reset login status
                          console.log("Sub Menü ve Parent Menüler çekilemedi.");
                          this.logout();
                        } else {
                          window.location.reload();

                        }

                      } else {
                        Helpers.setLoading(false);
                        // reset login status
                        console.log("Applications(Ticari, BackOffice ve Stok) URL'leri alınamadı.");
                        this.logout();
                      }

                      return tokenresponsemodel;

                    }).catch(ex => {
                      Helpers.setLoading(false);
                      // reset login status
                      console.log("DashBoard Itemlerini Alamadı.");
                      this.logout();
                    });
                } else {
                  console.log("Token Tanımsız.");
                  this.logout();
                }
              } else {
                Helpers.setLoading(false);
                console.log("TokenResponseModel Alınamadı.");
                this.logout();
                return new TokenResponseModel();
              }
            }).catch(ex => {
              Helpers.setLoading(false);
              console.log("Kullanıcı Bilgisi Çekilemedi.");
              this.logout();
              return new TokenResponseModel();
            });
        }
        else {
          return tokenresponsemodel;
        }

      }).catch(ex => {
        Helpers.setLoading(true);
        console.log("Token Alınamadı.");
        this.logout();
        return new TokenResponseModel();
      });
  }


  public async login(tokenmodel: TokenRequestModel) {

    var authenticationStatus = false;

    await this.clearCache();
    return await this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/Account/PortalLogin', tokenmodel)
      // return await this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/Account/PageLogin', tokenmodel)
      .then(async responsetoken => {
        const tokenresponsemodel = (responsetoken || new TokenResponseModel()) as TokenResponseModel;
        if (tokenresponsemodel.Token != null && tokenresponsemodel.Token != undefined) {
          tokenmodel.Password = '';
          localStorage.setItem('DashboardToken', JSON.stringify(tokenresponsemodel));
          localStorage.setItem('DashboardPass', JSON.stringify(tokenmodel));
          return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetAuthorizedUserInfo')
            .then(async result => {
              const userresponsemodel = (result || new UserResponseModel()) as UserResponseModel;
              if (tokenresponsemodel) {
                if (tokenresponsemodel.Token !== undefined) {
                  if (tokenmodel.FirmId > 0) {
                    userresponsemodel.FirmId = tokenmodel.FirmId;
                  }
                  localStorage.setItem('DashboardUser', JSON.stringify(userresponsemodel));
                  return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice,'/api/Dashboard/GetDashboardItems?UserId=' + userresponsemodel.Id)
                    .then(async response => {
                      const dashboardItems = (response || new DashboardItemResponseModel()) as DashboardItemResponseModel;

                      if (dashboardItems.Applications.length > 0) {
                        localStorage.setItem('DashboardItems', JSON.stringify(dashboardItems));
                        this.results = dashboardItems.Applications;
                        // tslint:disable-next-line:max-line-length
                        const applicationmenustatus = await this.getApplicationMenus();
                        await this.GetParameters();

                        if (applicationmenustatus !== true) {
                          Helpers.setLoading(true);
                          // reset login status
                          console.log("Sub Menü ve Parent Menüler çekilemedi.");
                          this.logout();
                        }

                      } else {
                        Helpers.setLoading(false);
                        // reset login status
                        console.log("Applications(Ticari, BackOffice ve Stok) URL'leri alınamadı.");
                        this.logout();
                      }

                      return tokenresponsemodel;

                    }).catch(ex => {
                      Helpers.setLoading(false);
                      // reset login status
                      console.log("DashBoard Itemlerini Alamadı.");
                      this.logout();
                    });
                } else {
                  console.log("Token Tanımsız.");
                  this.logout();
                }
              } else {
                Helpers.setLoading(false);
                console.log("TokenResponseModel Alınamadı.");
                this.logout();
                return new TokenResponseModel();
              }
            }).catch(ex => {
              Helpers.setLoading(false);
              console.log("Kullanıcı Bilgisi Çekilemedi.");
              this.logout();
              return new TokenResponseModel();
            });
        }
        else {
          return tokenresponsemodel;
        }

      }).catch(ex => {
        Helpers.setLoading(true);
        console.log("Token Alınamadı.");
        this.logout();
        return new TokenResponseModel();
      });
  }

  public async GetParameters() {
    await this._parameterService.LoadParameters(AppHelper.GetParameterList().ParameterGroupNameList)
      .catch((error: any) => console.log(error || 'Server error'));
  }

  public async getApplicationMenus() {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Application/GetApplicationMenus')
      .then((submenuresponse) => {
        const menudata = (submenuresponse || new Array<MenuResponseModel>()) as Array<MenuResponseModel>;
        if (menudata != null && menudata.length > 0) {
          this.menuresults = menudata;
          localStorage.setItem('DashboardMenus', JSON.stringify(this.menuresults));
          localStorage.removeItem('Captcha');
          return true;
        } else {
          return false;
        }

      }).catch(ex => {
        this.menuresults = new Array<MenuResponseModel>();
        return false;
      });
  }

  public logoutNoneService() {
    Helpers.RemoveModal();
    this.clearCache();
    this.LoginRouter(null);
  }

  public logout(state: RouterStateSnapshot = null) {
    this.LoginRouter(state);
    const tokenresponsemodel = JSON.parse(localStorage.getItem('DashboardToken')) as TokenResponseModel;
    Helpers.setLoading(false);
    if (tokenresponsemodel !== null && tokenresponsemodel !== undefined) {

      this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/Account/LogOut', null)
        .then(result => {
          Helpers.RemoveModal();
          this.clearCacheLogOut();
          this.LoginRouter(state);
        }).catch(ex => {
          Helpers.RemoveModal();
          this.clearCacheLogOut();
          this.LoginRouter(state);
        });
    } else {
      Helpers.RemoveModal();
      this.clearCacheLogOut();
      this.LoginRouter(state);
    }
  }

  public unauthorized() {
    Helpers.RemoveModal();
    this.clearCache();
    this.LoginRouter();
  }

  public clearCache() {
    const CaptchaKey = localStorage.getItem('Captcha');
    const firmList = localStorage.getItem('firmList');
    const selectedFirm = localStorage.getItem('selectedFirm');
    localStorage.removeItem('DashboardToken');
    localStorage.removeItem('DashboardUser');
    localStorage.removeItem('DashboardPass');
    localStorage.removeItem('DashboardMenus');
    localStorage.clear();
    this._runtime.clearCache();
    (CaptchaKey !== "null" && CaptchaKey !== null && CaptchaKey !== undefined && CaptchaKey !== '') ? localStorage.setItem('Captcha', CaptchaKey) : true;
    (firmList !== "null" && firmList !== null && firmList !== undefined && firmList !== '') ? localStorage.setItem('firmList', firmList) : true;
    (selectedFirm !== "null" && selectedFirm !== null && selectedFirm !== undefined && selectedFirm !== '') ? localStorage.setItem('selectedFirm', selectedFirm) : true;
    // Helpers.setLoading(false);
  }

  public clearCacheLogOut() {
    localStorage.removeItem('DashboardToken');
    localStorage.removeItem('DashboardUser');
    localStorage.removeItem('DashboardPass');
    localStorage.removeItem('DashboardMenus');
    localStorage.removeItem('Captcha');
    localStorage.removeItem('firmList');
    localStorage.removeItem('selectedFirm');
    localStorage.clear();
    this._runtime.clearCache();
    // Helpers.setLoading(false);
  }

  public LoginRouter(state: RouterStateSnapshot = null) {
    if (this._router.url === '/login?returnUrl=%2Flogout') {
      this._router.navigate(['/login']);
    } else if (this._router.url !== '/login' &&
      this._router.url !== '/login?returnUrl=%2Findex') {
      if (state === null) {
        this._router.navigate(['/login']);
        // location.reload();
      } else {
        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      }
    }
  }

  public CheckToken(state: RouterStateSnapshot = null) {
    const tokenresponsemodel = JSON.parse(localStorage.getItem('DashboardToken')) as TokenResponseModel;
    // Helpers.setLoading(false);
    if (tokenresponsemodel !== null && tokenresponsemodel !== undefined) {

      this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/Account/CheckToken', tokenresponsemodel.Token)
        .then(result => {
          // Helpers.RemoveModal();
          // this.clearCache();
          // this.LoginRouter(state);
        }).catch(ex => {
          console.log('CheckToken Hata: ', ex);

          this.clearCache();
          this.LoginRouter(state);
          Helpers.RemoveModal();
        });
    } else {
      this.LoginRouter(state);
      Helpers.RemoveModal();
      this.clearCache();

    }
  }

  public async GetReCaptcha(captchaKey: string) {
    const reCaptchaModel = new GetReCaptchaRequestModel;
    reCaptchaModel.CaptchaKey = captchaKey;
    return await this._apiservice.Post(ApiUrlEnum.BackOffice, '/api/Account/GetReCAPTCHA', reCaptchaModel)
      .then((result) => {
        const ReCaptcha = (result || new GetReCaptchaResponseModel()) as GetReCaptchaResponseModel;
        return ReCaptcha;
      }).catch(ex => {
        return new GetReCaptchaResponseModel();
      });
  }

}
